<template>
    <v-container >
        <fulldialog-usuario v-if="dialog"/>
        <div v-if="!dialog">
            <div class="text-h4 mb-5 mt-5">Usuarios</div>
            <v-card :loading="loadingUsuarios">
                <v-card-title>
                    <v-text-field
                        v-model="buscarUsuarios"
                        append-icon="mdi-account-search-outline"
                        label="Buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                    :headers="headersUsuarios"
                    :items="usuarios"
                    :search="buscarUsuarios"
                >
                    <template v-slot:item.estado="{ item }">
                        <v-chip
                            :color="getColorEstado(item.estado)"
                            outlined
                            pill
                            small
                        >
                            {{ item.estado }}
                        </v-chip>
                    </template>
                    <template v-slot:item.acciones="{ item }">
                        <v-icon
                            class="mr-2"
                            @click="editarUsuario(item)"
                        >
                            mdi-account-edit-outline
                        </v-icon>
                    </template>
                </v-data-table>
            </v-card>
        </div>
        <v-btn fab dark color="teal lighten-1" @click="abrirDialog()" fixed style="bottom: 37px; right: 30px;">
            <v-icon>mdi-plus</v-icon>
        </v-btn>
    </v-container>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import formatearFecha from '../../mixins/formatearFecha'
    import FullDialogUsuario from './FullDialogUsuario';
    import axios from 'axios';
    axios.defaults.withCredentials = true;
    axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    export default {
        name: 'Usuarios',
        mixins: [formatearFecha],
        data: () => ({
            buscarUsuarios: '',
            headersUsuarios: [
                {
                    text: 'Nombre',
                    align: 'start',
                    filterable: true,
                    sortable: true,
                    value: 'nombre'
                },
                {
                    text: 'Apellidos',
                    filterable: true,
                    sortable: true,
                    value: 'apellidos',
                },
                {
                    text: 'Email',
                    filterable: true,
                    sortable: true,
                    value: 'email'
                },
                {
                    text: 'Fecha creación',
                    filterable: false,
                    sortable: true,
                    value: 'created_at'
                },
                {
                    text: 'Estado',
                    filterable: true,
                    sortable: true,
                    value: 'estado'
                },
                {
                    text: '',
                    filterable: false,
                    sortable: false,
                    value: 'acciones'
                }
            ],
            loadingUsuarios: false,
        }),
        methods: {
            ...mapActions('usuarios', { setDialogUsuario: 'setDialog', setUsuario:'setUsuario', setUsuarios:'setUsuarios', setNuevoUsuario:'setNuevoUsuario', setGruposUsuario:'setGruposUsuario'}), // Mapeo las acciones y las identifico con nombres distintos para que no se pisen las acciones setDialog de usuarios y grupos
            ...mapActions(['setLoading', 'setSnackbar']),
            getColorEstado(estado){
                return estado == 'Habilitado' ? 'success' : 'default'
            }, 
            abrirDialog(){
                this.setNuevoUsuario();
                this.setDialogUsuario(true);
            },
            async editarUsuario(usuario){
                this.setLoading(true);
                await axios.get("/api/usuarios/"+usuario.email).then(respuesta =>{
                    this.setUsuario(respuesta.data);
                    this.setLoading(false);
                    this.setDialogUsuario(true);
                });
            }    
        },
        mounted() {
            this.loadingUsuarios = true;
            axios.get("/api/usuarios").then(respuesta => {
                this.setUsuarios(respuesta);
                this.loadingUsuarios = false;
            }).catch(error =>{
                this.loadingUsuarios = false;
                this.setSnackbar({
                    snackbar: true,
                    tipo: 'error',
                    mensaje: 'No se han podido recuperar los usuarios'
                });
            });
        },
        computed: {
            ...mapState('usuarios', ['usuarios', 'dialog']),
        },
        components: {
            'fulldialog-usuario': FullDialogUsuario,
        }
    }
</script>